//西班牙语
export default {
    login1: '¿Ya tienes una cuenta? ',
    login2: 'Ir a iniciar sesión',
    login3: '¿Restablecer contraseña? ',
    login4: 'Empieza a usar 51shopy',
    login5: '¿Olvidó su contraseña?',
    login6: 'Regístrate ahora',
    login7: 'Correo electrónico',
    login8: 'Código de verificación',
    login9: 'Ingrese el código de verificación',
    login10: 'contraseña',
    login11: 'Confirmar contraseña',
    login12: 'Por favor ingrese su contraseña nuevamente',
    login13: 'Registrarse',
    login14: 'Siguiente paso',
    login15: 'Enviar',
    login16: 'Enviar código de verificación',
    login17: '¡Por favor ingrese la dirección de correo electrónico y el código de verificación correctos! ',
    login18: '¡Las contraseñas ingresadas dos veces no coinciden!',
    login19: 'Se ha enviado el código de verificación',
    login20: 'La dirección de correo electrónico no puede estar vacía',
    login21: 'El formato del correo electrónico es incorrecto',
    login22: 'El código de verificación no puede estar vacío',
    login23: 'La longitud del código de verificación es de 4 caracteres',
    login24: 'La contraseña no puede estar vacía',
    login25: 'La longitud de la contraseña no puede ser inferior a 6 caracteres',
    login26: '¡Contraseña cambiada exitosamente! ',
    login27: '¡Registro exitoso! ',
    login28: 'Inicio de sesión exitoso',
    login29: 'El nombre de la cuenta no puede estar vacío',
    login30: 'Inicie sesión en su cuenta a continuación para comenzar',
    login31: 'Cuenta',
    login32: 'Haga clic para iniciar sesión',
    login33: "Compra productos de calidad y disfruta de bonificaciones",
    login34: "Regístrate para disfrutar de un maravilloso regalo",
    login35: "Iniciar sesión",
    login36: "Registrarse",

    home1: 'Popular',
    home2: '¿Estás seguro que deseas cerrar la sesión? ',
    home3: 'Mensaje',
    home4: 'OK',
    home5: 'Cancelar',
    home6: 'Fans',
    home7: 'Seguir',
    home8: 'Centro Personal',
    home9: 'Lo compré',
    home10: 'Lo vendí',
    home11: 'Mi billetera',
    home12: 'Salir',
    home13: 'Total',
    home14: 'artículos',
    home15: 'Asentamiento',
    home16: 'Precio asequible',
    home17: 'Logística rápida',
    home18: 'Garantía de calidad',
    home19: 'Sobre nosotros',
    home20: 'Centro de ayuda',
    home21: 'Servicio postventa',
    home22: 'Entrega y aceptación',
    home23: 'Cooperación empresarial',
    home24: 'Recomendaciones de búsqueda',
    home25: 'Enlaces amistosos',
    home26: 'Seguir',
    home27: 'Ya seguido',
    home28: 'Comprar ahora',
    home29: 'Añadir al carrito',
    home30: '¡Recogida exitosa! ',
    home31: '¡Cancelar la recogida con éxito! ',
    home32: '¿Estás seguro de que deseas dejar de seguir?',
    home33: '¡Cancelado exitosamente! ',
    home34: '¡Sigue el éxito! ',
    home35: 'El contenido no puede estar vacío',
    home36: '¡Comentario exitoso!',
    home37: 'Reseñas de productos',
    home38: 'Evaluar ahora',
    home39: 'Evaluación',
    home40: 'Historia',
    home41: '¡Dejar de seguir exitosamente! ',
    home42: 'Este tipo es muy misterioso y no tiene biografía. ',
    home43: 'Inicio',
    number1: 'Cuenta',
    number2: 'Centro Personal',
    number3: 'Billetera',
    number4: 'Favoritos',
    number5: 'Atención',
    number6: 'Fans',
    number7: 'Historial de navegación',
    number8: 'Gestión de transacciones',
    number9: 'He publicado',
    number10: 'compré',
    number11: 'lo vendí',
    number12: 'Carro',
    number13: 'Página de inicio personal',
    number14: 'Atención al cliente',
    number15: 'Configuración',
    number16: 'Añadir nueva dirección',
    number17: 'Modificar dirección',
    number18: '¡Solo se pueden cargar archivos de imagen!',
    number19: '¡El tamaño del archivo no puede superar los 10 MB!',
    number20: 'Imagen cargada exitosamente',
    number21: 'Equilibrio',
    number22: 'Recoger objetos',
    number23: 'Información personal',
    number24: 'Editar',
    number25: 'Enviar',
    number26: 'Apodo',
    number27: 'Perfil personal',
    number28: 'dirección de entrega',
    number29: 'Añadir',
    number30: 'Defecto',
    number31: 'No pagado',
    number32: 'Esperando entrega',
    number33: 'Completado',
    number34: 'Cancelado',
    number35: 'Pendiente de revisión',
    number36: 'Aprobado',
    number37: 'Rechazado',
    number38: 'Pedido completado',
    number39: '¡Pago del pedido exitoso!',
    number40: '¡Pedido cancelado exitosamente! ',
    number41: '¡Retiro exitoso! ',
    number42: 'Recarga',
    number43: 'Retirar',
    number44: 'Historial de consumo',
    number45: 'Nº pedido',
    number46: 'nombre del pago',
    number47: 'Todos',
    number48: 'Consulta',
    number49: 'Nº pedido',
    number50: 'nombre del pago',
    number51: 'moneda 51',
    number52: 'Estado del pedido',
    number53: 'Hora de creación del pedido',
    number54: 'Hora de actualización del pedido',
    number55: 'Operación',
    number56: 'Pagado',
    number57: 'Cancelar pedido',
    number58: 'Detalles',
    number59: 'number',
    number60: 'enviado',
    number61: 'pendiente',
    number62: 'Registro de retiro',
    number63: 'id de usuario',
    number64: 'Monto del retiro',
    number65: 'Estado',
    number66: 'Tiempo de creación',
    number67: 'Retirar de la billetera',
    number68: 'Retirar',
    number69: 'Detalles del pedido de la billetera',
    number70: 'Todos los pedidos',
    number71: 'Pago pendiente',
    number72: 'Esperando entrega',
    number73: 'Completado',
    number74: 'Cancelado',
    number75: 'Pagado',
    number76: 'Todos los envíos',
    number77: 'numberde orden logística',
    number78: '¡Envío exitoso!',
    number79: 'lo vendí',
    number80: 'Aún no hay datos del pedido',
    number81: 'Nº pedido',
    number82: 'Hora del pedido',
    number83: 'Persona de orden',
    number84: 'Hora de cambio',
    number85: 'detalles',
    number86: 'Total',
    number87: 'enviado',
    number88: 'Detalles',
    number89: 'Rellene el Nº pedido logístico',
    number90: 'numberde orden logística',
    number91: 'Por favor ingrese el Nº pedido logístico',
    number92: '¡Cancelación exitosa!',
    number93: '¡Éxito!',
    number94: '¡Pedido con entrega retrasada exitoso!',
    number95: 'compré',
    number96: 'Pagar ahora',
    number97: 'Confirmar recepción',
    number98: 'Entrega retrasada',
    number99: 'Cancelar pedido',
    number100: 'Usuario vendedor',
    number101: 'Mi colección',
    number102: 'Mis fans',
    number103: 'Mis seguidores',
    number104: 'nombre del pago',
    number105: 'moneda 51',
    number106: 'Estado del pedido',
    number107: 'Hora de pago',
    number108: 'He pagado',
    number109: '¡Pago del pedido exitoso! ',
    number110: 'Todos los productos',
    number111: '¿Está seguro de que desea eliminar el producto?',
    number112: '¡Eliminado exitosamente! ',
    number113: '¡Cancelado exitosamente! ',
    number114: '¿Está seguro de que desea colocar el producto en el estante?',
    number115: '¿Está seguro de que desea eliminar el producto?',
    number116: '¡Éxito! ',
    number117: 'En el estante',
    number118: 'listo para usar',
    number119: 'Borrar',
    number120: 'Ver detalles',
    cart1: 'Información del producto',
    cart2: 'precio unitario',
    cart3: 'Cantidad',
    cart4: 'Subtotal',
    cart5: 'operación',
    cart6: 'precio unitario',
    cart7: '¿Estás seguro de eliminar?',
    cart8: 'Confirmar',
    cart9: 'Cancelar',
    cart10: 'eliminar',
    cart11: 'La lista del carrito de compras está vacía',
    cart12: 'artículos, total de artículos',
    cart13: 'Total',
    cart14: 'Pagar',
    cart15: 'Añadir dirección',

    cart16: 'Se debe completar uno de Telegram y watchApp',
    cart17: '¡Configuración de la información del usuario exitosa!',
    cart18: '¡Por favor seleccione o complete la dirección de entrega! ',
    cart19: '¡Pedido creado exitosamente! ',
    cart20: 'dirección de entrega',
    cart21: 'Debes agregar una dirección de entrega antes de enviar el pedido. ',
    cart22: 'Consignatario',
    cart23: 'Información de contacto',
    cart24: 'dirección de entrega',
    cart25: 'Cambiar dirección',
    cart26: 'Añadir dirección',
    cart27: 'Información del producto',
    cart28: 'Precio unitario',
    cart29: 'Cantidad',
    cart30: 'Pago real',
    cart31: 'Precio total',
    cart32: 'Detalles del importe',
    cart33: 'Importe total a pagar',
    cart34: 'Enviar pedido',
    cart35: 'Cambiar dirección de entrega',
    cart36: 'Cancelar',
    cart37: 'Está bien',
    cart38: 'Información del usuario',
    cart39: 'Enviar',
    cart40: 'El apellido no puede estar vacío',
    cart41: 'El nombre no puede estar vacío',
    cart42: 'El número de móvil no puede estar vacío',
    cart43: 'El país no puede estar vacío',
    cart44: 'La provincia/municipio/distrito no puede estar vacío',
    cart45: 'La ciudad no puede estar vacía',
    cart46: 'La dirección detallada no puede estar vacía',
    cart47: 'El código postal no puede estar vacío',
    cart48: '¡Dirección modificada exitosamente! ',
    cart49: '¡Dirección agregada exitosamente! ',
    cart50: 'apellido',
    cart51: 'nombre',
    cart52: 'País',
    cart53: 'Provincia/Municipio/Región',
    cart54: 'ciudad',
    cart55: 'Dirección detallada',
    cart56: 'Código postal',
    cart57: 'Número de teléfono de contacto',
    cart58: '¿Es predeterminado?',
    cart59: 'Inicio',
    cart60: 'Atención al cliente',
    cart61: 'Publicar',
    cart62: 'Mi',
    cart63: 'Carro',
    cart64: 'Tiempo de envío',
    cart65: 'Hora de pago',
    cart66: 'Dir. entrega',
    cart67: 'Pago real',
    cart68: 'Enviar a',
    cart69: 'Productos',
    cart70: 'Puedes solicitar factura',
    cart71: 'Información del pedido',
    cart72: 'Comerciante',
    cart73: '¡Envío exitoso! ',
    cart74: 'Copia exitosa',
    cart75: 'Error al copiar',
    cart76: 'proporción',
    cart77: 'Límite de crédito',
    cart78: 'Transferencia',
    cart79: 'Monto de recarga',
    cart80: 'Recarga',
    cart81: 'Clasificación',
    setup1: 'Información personal',
    setup2: 'Mi dirección de entrega',
    setup3: 'Mi perfil',
    setup4: 'Cuenta y seguridad',
    setup5: 'Privacidad',
    setup6: 'General',
    setup7: 'Ayuda y comentarios',
    setup8: 'Acerca de nosotros',
    setup9: 'Cerrar sesión',
    setup10: 'Mensaje de la estación',
    setup11: 'Aún no hay datos',
    setup12: '¡Añadido al carrito exitosamente!',
    setup13: '¡Error al agregar al carrito!',

    setup14: 'Edición de producto',
    setup15: 'Lanzamiento del producto',
    setup16: 'Imagen de portada del producto',
    setup17: 'Categoría de producto',
    setup18: 'Nombre del producto',
    setup19: 'Precio del producto (CNY)',
    setup20: 'Descripción del producto',
    setup21: 'Imágenes del producto (Máx. 10 imágenes)',
    setup22: 'Restablecer',
    setup23: '¡Producto creado exitosamente! ',


    setup24: '¡Stock de producto insuficiente! ',
    setup25: 'Método de pago',
    setup26: '51coin',
    setup27: 'transferencia',
    setup28: 'Enlace de producto o enlace de nombre/artículo',
    setup29: '¡El usuario no es vendedor y no puede publicar productos! ',
    setup30: '¡Operación no humana detectada! ',
    setup31: 'Inventario de productos',
    setup32: 'Vistas',
    setup33: '¡Pedido enviado exitosamente! ',
    setup34: 'Ver pedido',
    setup35: 'Inventario de productos',
    setup36: 'La categoría del producto no puede estar vacía',
    setup37: 'El nombre del producto no puede estar vacío',
    setup38: 'La descripción del producto no puede estar vacía',
    setup39: 'El inventario de productos no puede estar vacío',
    setup40: 'El precio del producto no puede estar vacío',
    setup41: 'La imagen de portada no puede estar vacía',
    setup42: 'La imagen del producto no puede estar vacía',
    setup43: 'La transferencia se ha realizado y está esperando confirmación',
    setup44: '¡Seleccione el método de transferencia! ',
    setup45: 'Tiempo de finalización',
    setup46: 'Ficha de 51',
    setup47: 'Pago Transf. ',
    setup48: 'Método de transferencia',
    setup49: "Detalles del producto",
    setup50: "Comprador",
    setup51: "El costo de envío del producto es",
    setup52: "Tarifa de envío",
    setup53: "Cantidad de ventas",
    setup54: "Cantidad mínima de compra",
    setup55: "Agregar",
    setup56: "Se ha recibido la cuenta",
    setup57: "Información de contacto del beneficiario",
    setup58: "Información de contacto del comerciante",
    setup59: "Información de contacto del comprador",
    setup60: "Copiar",
    setup61: "Popular",
    setup62: "Rellene al menos un campo",
    setup63: "Contáctenos",
    setup64: "Presupuesto de envío",
    setup65: "Suscríbete a nosotros",
    setup66: "Cooperación entre celebridades de Internet en el extranjero",
    setup67: "Problemas de pago y posventa",
    setup68: "Dividendos del usuario",

    setup69: "Tipo de moneda",
    setup70: "Tipo de cambio",
    setup71: "Tarifa de manejo",
    setup72: "Recibo real",
    setup73: "Monto mínimo de retiro",
    setup74: "Moneda",
    setup75: "Tarifa de manejo",
    setup76: "Recibo real",

    setup78: "Código de invitación",
    setup79: "Por favor ingrese el código de invitación",
    setup80: "El código de área móvil no puede estar vacío",
    setup81: "Código de área",
    setup82: "Cancelar hora",
    setup83: "Detalles del retiro",
    setup84: "Detalles del dividendo",
    setup85: "¿Está caducado?",
    setup86: "Si se debe utilizar",
    setup87: "No expirado",
    setup88: "Expirado",
    setup89: "No utilizado",
    setup90: "Ya usado",
    setup91: "Parcialmente usado",
    setup92: "reembolso",
    setup93: "Reembolso por uso",
    setup94: "Reembolso restante",
    setup95: "Si se debe utilizar",
    setup96: "¿Está caducado?",
    setup97: "Tiempo de expiración",
    setup98: "Tiempo de reembolso",
    setup99: "Compartir alianza",
    setup100: "Cancelar pago",
    setup101: "Cerrar la interfaz",
    setup102: "Pago en USDT",
    setup103: "Total a pagar",
    setup104: "Monto de la transacción del pedido",
    setup105: "Red",
    setup106: "Pagas por la red",
    setup107: "Pago exitoso",
    setup108: "Dirección de la billetera del beneficiario",
    setup109: "Por favor, verifique cuidadosamente que el importe real del pago coincida con el importe transferido. Si hay algún error, usted asumirá las consecuencias",
    setup110: "Tiempo de expiración",
    setup111: "Esperando pago",
    setup112: "Pago exitoso",
    setup113: "Pedido expirado",
    setup114: "Verificar transacciones de blockchain",
    setup115: "",
    setup116: "",
    setup117: "",
    setup118: "",
    setup119: "",

    setup130: "Acerca de nosotros",
    setup131: "Relacionado con la entrega",
    setup132: "Otro",
    setup133: "Política de envíos",
    setup134: "Hora de entrega/recogida del paquete",
    setup135: "Condiciones de servicio",
    setup136: "Método de pago",
    setup137: "Política de devoluciones",
    setup138: "Política de privacidad",
    setup139: "Tecnología de red espacial Co., Ltd.",
    setup140: "Horas de trabajo:",
    setup141: "Persona de contacto:",
    setup142: "Correo electrónico de la empresa:",
    setup143: "Código postal:",
    setup144: "Dirección: ",

    setup0140: "De lunes a viernes (9:00-18:00)",
    setup0141: "Sr. Liang",
    setup0143: "999077",
    setup0144: "Sala 341, 3.er piso, Edificio Industrial Público, 56 Hoi Yuen Road, Kwun Tong, Hong Kong",

    setup145: "Acuerdo de envío de paquetes internacionales",
    setup146: "Debido a las particularidades del transporte internacional, debe cumplir con las normas de transporte internacional de paquetes. Lea atentamente y acepte los siguientes términos y condiciones.",
    setup147: "Estándar de compensación del paquete:",
    setup148: "Si sus productos se pierden, se pierden, se dañan, se retrasan o son retenidos por la aduana durante el transporte por causas ajenas a 51shopy, 51shopy no se responsabilizará de ninguna compensación. Tampoco asumimos ninguna responsabilidad por pérdidas indirectas de beneficios no realizados. Para obtener más información, consulte 'Seguro e indemnización del paquete'.",
    setup149: "51shopy no se hace responsable de la compensación en los siguientes casos (para paquetes no asegurados):",
    setup150: "1. No se concederá ninguna compensación por la pérdida de correo causada por fuerza mayor, como desastres naturales o razones aduaneras;",
    setup151: "2. Si los envíos infringen prohibiciones o restricciones, las autoridades competentes los confiscarán o los procesarán de conformidad con las leyes y reglamentos pertinentes sin indemnización;",
    setup152: "3. Al enviar un paquete, si este se encuentra en buen estado, sin señales de desmontaje ni pérdida de peso, pero presenta piezas internas faltantes o dañadas, no se realizará ninguna compensación;",
    setup153: "4. Si el seguimiento del correo muestra que el paquete no se entregó correctamente y la empresa de logística confirma que la aduana lo ha confiscado, prevalecerá la investigación de la empresa de logística y no se otorgará ninguna compensación.",
    setup154: "5. No se dará ninguna compensación si el correo se pierde o falta el contenido por culpa del cliente o del propio correo;",
    setup155: "6. Si el cliente no realiza una consulta ni presenta una reclamación desde la fecha de entrega del correo electrónico hasta el vencimiento del plazo de consulta, no se proporcionará ninguna compensación;",
    setup156: "7. Si el correo internacional es retenido, confiscado o destruido por el país de destino de conformidad con su legislación nacional, no se proporcionará ninguna compensación.",
    setup157: "Artículos prohibidos",
    setup158: "Cumplir con la normativa de nuestro país sobre artículos prohibidos y restringidos:",
    setup159: "1. Cumplir con el anuncio de la Oficina Estatal de Correos, el Ministerio de Seguridad Pública y el Ministerio de Seguridad del Estado sobre la emisión del 'Reglamento sobre la Gestión de Artículos Prohibidos'.",
    setup160: "2. Cumplir con las disposiciones de la Orden N.° 43 de la Administración General de Aduanas (Lista de Artículos Prohibidos y Restringidos para la Importación y Exportación de la República Popular China).",
    setup161: "Artículos que no se pueden enviar por correo",
    setup162: "1. Artículos cuya circulación y transporte están prohibidos según las leyes nacionales.",
    setup163: "2. Mercancías peligrosas explosivas, inflamables, corrosivas, radiactivas o tóxicas.",
    setup164: "3. Publicaciones, libros, materiales o artículos que contengan contenido reaccionario u obsceno.",
    setup165: "4. Varias monedas.",
    setup166: "5. Artículos que violan la salud pública.",
    setup167: "6. Artículos perecederos.",
    setup168: "7. Animales vivos (excepto abejas, gusanos de seda y sanguijuelas, siempre que el embalaje garantice la seguridad de los trabajadores).",
    setup169: "8. Un embalaje inadecuado puede suponer un peligro para los trabajadores o contaminar o dañar otros artículos embalados.",
    setup170: "9. Otros artículos no aptos para envío por correo.",
    setup171: "Artículos cuya entrega está prohibida según la práctica postal",
    setup172: "1. Artículos cuya calidad o embalaje puedan causar daños a los trabajadores postales o contaminar/dañar otros paquetes o equipos postales.",
    setup173: "2. Artículos con sellos metálicos u otros bordes afilados que puedan interferir con el procesamiento postal.",
    setup174: "3. Diversos tipos de armas de fuego, municiones, materiales o contenedores explosivos, inflamables, corrosivos y radiactivos, venenos fuertes, estupefacientes, productos bioquímicos y materiales infecciosos.",
    setup175: "4. Cualquier publicación, material de propaganda o material impreso que pueda poner en peligro la seguridad y la estabilidad social o que contenga contenido obsceno.",
    setup176: "5. Diversos elementos que puedan poner en peligro la salud pública.",
    setup177: "6. Documentos o artículos cuya circulación no está permitida en el país receptor.",
    setup178: "Métodos de pago disponibles",
    setup179: "El sitio web admite múltiples métodos de pago, incluyendo tarjetas de crédito/débito, WeChat, Alipay, etc. Si necesita realizar pagos frecuentes o deducciones de depósito en garantía, también puede usar el saldo para pagar.",
    setup180: "- Si se produce un reembolso por una orden de compra con tarjeta de crédito/débito, se reembolsará a la cuenta original; el reembolso por la recarga del saldo también se reembolsará a la cuenta original",
    setup181: "- Si se produce un reembolso por pagos de pedidos realizados a través de WeChat, Alipay, etc., el reembolso se devolverá a la cuenta original;",
    setup182: "- Si se produce un reembolso por el pago del saldo, se reembolsará al saldo de la cuenta;",
    setup183: "Política de privacidad del usuario de 51shopy",
    setup184: "La seguridad de su información personal es muy importante para nosotros y valoramos su confianza. Bajo ninguna circunstancia venderemos ni divulgaremos su información personal a terceros. Protegeremos la seguridad y privacidad de cualquier información personal que nos proporcione y solo la utilizaremos como se describe aquí. Si tiene alguna pregunta, sugerencia o comentario sobre esta Política de Privacidad, puede contactarnos en cualquier momento visitando el sistema de atención al cliente en línea de 51shopy o su cuenta de servicio oficial.",
    setup185: "Esta política no se aplica a los servicios que le prestan otros terceros, ni a los servicios para los que hemos establecido políticas de privacidad independientes.",
    setup186: "Lea y comprenda esta política detenidamente antes de utilizar los servicios de 51shopy. Su aceptación de esta política de privacidad implica que ha comprendido las funciones que ofrece esta aplicación y la información personal necesaria para ejecutarlas.",
    setup187: "Los derechos de propiedad y operación de los servicios de usuario registrados relevantes pertenecen a ",
    setup188: "1. ¿Qué información personal recopilamos?",
    setup189: "Puede optar por usar o visitar nuestro sitio web sin revelar información personal ni de transacciones, pero necesita registrarse para disfrutar de nuestro servicio completo. Si nos proporciona su información, acepta la transferencia y el almacenamiento de la misma en nuestros servidores.",
    setup190: "51shopy recopila la información personal que usted proporciona al usar el sitio web, incluyendo su nombre, información de contacto, dirección de correo electrónico, nombre de usuario y contraseña de 51shopy, y otra información necesaria para crear una cuenta. Además de la información personal que podemos recopilar y procesar durante el registro, también recopilamos, almacenamos y procesamos la siguiente información sobre nuestros usuarios en 51shopy:",
    setup191: "1) Información de compra",
    setup192: "2) Información de la cuenta de servicio",
    setup193: "3) Información de pago (hora de pago, importe del pago, canal de pago, etc.)",
    setup194: "4) Buscar información del historial de navegación (contenido de búsqueda, comportamiento de clics en enlaces, historial de navegación, historial de visualización de clics, etc.)",
    setup195: "5) Cookies y otra información del ordenador",
    setup196: "Nos hemos asociado con Microsoft Clarity y Microsoft Advertising para registrar cómo usa e interactúa con nuestro sitio web mediante métricas de comportamiento, mapas de calor y repeticiones de sesiones para mejorar y comercializar nuestros productos y servicios. Los datos de uso del sitio se recopilan mediante cookies propias y de terceros, así como otras tecnologías de seguimiento, para determinar la popularidad de los productos y servicios, así como las actividades en línea. Además, utilizamos esta información para la optimización del sitio, con fines de seguridad y prevención de fraudes, y para fines publicitarios. Para obtener más información sobre cómo Microsoft recopila y utiliza sus datos, visite",
    setup197: "Declaración de privacidad de Microsoft",
    setup198: "2. ¿Cómo utilizamos su información personal?",
    setup199: "No venderemos ni divulgaremos la información personal de ningún usuario y nos esforzamos por proteger su información y privacidad. Utilizaremos su información para brindarle mejores servicios, incluyendo:",
    setup200: "1) Comunicarnos con usted por correo electrónico y brindarle una serie de nuestros servicios, incluidos servicios de consultoría, servicios de información de pedidos, servicios de información de paquetes, servicios posventa de productos, etc.",
    setup201: "2) Comunicarle las actividades de la plataforma por correo electrónico, correo interno, etc., lo que incluye proporcionarle cupones, descuentos de envío y promociones especiales, y brindarle oportunidades para utilizar servicios de terceros.",
    setup202: "3) Al buscar y explorar los enlaces de nuestros comercios asociados en 51shopy, su ID de usuario de 51shopy, sus comportamientos operativos e información relacionada (contenido de búsqueda, comportamiento de clics en el enlace, historial de navegación, historial de clics, etc.) se proporcionarán a la fuente del enlace de comportamiento operativo, para que podamos colaborar con nuestros comercios asociados y brindarle servicios eficientes y de alta calidad. Puede hacer clic para ver los comercios asociados de 51shopy (www.taobao.com, www.1688.com).",
    setup203: "De acuerdo con las leyes, regulaciones y estándares nacionales, en las siguientes circunstancias, los socios no necesitan su autorización o consentimiento para usar, transferir o divulgar su información personal:",
    setup204: "1) De acuerdo con los requisitos obligatorios de las leyes, reglamentos, órganos administrativos y judiciales y otras obligaciones legales;",
    setup205: "2) En la medida en que lo permitan las leyes y regulaciones, es necesario salvaguardar el interés público, la seguridad de la propiedad y protegerlo a usted o a otros usuarios de 51shopy, 51shopy, afiliados o socios de 51shopy de daños;",
    setup206: "3) Necesario para realizar las funciones principales de nuestros productos y/o servicios, o para proporcionarle los servicios que necesita;",
    setup207: "4) Procesar su información personal divulgada por usted u otra información personal que haya sido divulgada legalmente (como información personal divulgada legalmente a través de informes de noticias legales, divulgación de información gubernamental u otros canales) dentro de un alcance razonable;",
    setup208: "5) Manejar las disputas o controversias entre usted y los demás según sus necesidades;",
    setup209: "6) Cumplir con los acuerdos pertinentes firmados con usted (incluidos los acuerdos electrónicos en línea y las reglas de la plataforma correspondiente) u otros documentos legales;",
    setup210: "7) Uso basado en intereses públicos sociales y emergencias de salud pública y en cumplimiento de las leyes y regulaciones.",
    setup211: "Para los fines mencionados, también tiene derecho a cancelar esta notificación en cualquier momento. Puede iniciar sesión en el sitio web de 51shopy y configurarla usted mismo en la función personalizada.",
    setup212: "Tenga en cuenta que no compartiremos sus datos personales con ningún anunciante a menos que obtengamos su consentimiento. No solicitaremos ni divulgaremos información personal a niños ni a otras personas incapaces sin el consentimiento, el conocimiento y la presencia de sus tutores",
    setup213: "Por la presente, usted reconoce, comparte y transfiere información personal anónima, y ​​garantiza que el destinatario de los datos no pueda restaurar ni volver a identificar al titular de la información personal. Esto no constituye compartir, transferir ni divulgar públicamente información personal al exterior. El almacenamiento y procesamiento de dichos datos no requiere notificación ni su consentimiento.",
    setup214: "Podemos confiar a socios autorizados el procesamiento de su información personal para que puedan prestarle ciertos servicios o realizar ciertas funciones en nuestro nombre. Solo confiaremos el procesamiento de su información para los fines legítimos, adecuados, necesarios, específicos y claros que se indican en esta política, y los socios autorizados solo podrán acceder a la información necesaria para el desempeño de sus funciones. 51shopy no compartirá su dirección de correo electrónico, nombre de usuario y contraseña de la cuenta del sitio web de 51shopy, información de contacto ni otra información privada con nuestros socios.",
    setup215: "3. ¿Durante cuánto tiempo conservaremos su información?",
    setup216: "Una vez que registre correctamente una cuenta de 51shopy, guardaremos permanentemente su información personal. Si desea cancelar su cuenta o eliminar su información personal, comuníquese con el servicio de atención al cliente en línea.",
    setup217: "Según el RGPD, los responsables y encargados del tratamiento de datos están obligados a devolver o eliminar todos los datos personales tras la finalización del servicio o la expiración del contrato o acuerdo, a menos que exista una obligación legal de conservarlos.",
    setup218: "4. ¿Cómo protegemos su información personal?",
    setup219: "Tomaremos todas las medidas razonables y factibles para proteger su información personal. Tomaremos todas las medidas razonables y factibles para garantizar que no se recopile información personal irrelevante.",
    setup220: "5. Actualización de política",
    setup221: "Para brindarle una mejor experiencia con nuestros productos y servicios, trabajamos constantemente para mejorar nuestros productos, servicios y tecnologías. Cuando cambien los nuevos servicios y procesos comerciales, podremos actualizar nuestra política de privacidad para informarle sobre cambios específicos. Por favor, consulte esta página periódicamente y siga la política más reciente. Una vez publicada, será vinculante para usted.",
    setup222: "6. Contáctenos",
    setup223: "Si tiene alguna pregunta sobre esta declaración de privacidad, comuníquese con: ",
    setup224: "Lea atentamente las Condiciones de Servicio de 51shopy antes de registrarse como usuario y asegúrese de comprenderlas completamente. Lea atentamente y decida si acepta o no las Condiciones de Servicio de 51shopy, especialmente las condiciones de exención o limitación de responsabilidad, la legislación aplicable y la resolución de disputas. A menos que acepte estas Condiciones de Servicio de 51shopy, no tendrá derecho a registrarse, iniciar sesión ni utilizar los servicios de 51shopy. Su registro, inicio de sesión y uso se considerarán como su aceptación de las Condiciones de Servicio de 51shopy y su conformidad con las mismas.",
    setup225: "Las Condiciones de Servicio de 51shopy estipulan los derechos y obligaciones tanto de usted como de 51shopy en relación con los servicios de 51shopy (en adelante, 'Servicios'). 51shopy podrá actualizar las Condiciones de Servicio de 51shopy en cualquier momento. Las Condiciones de Servicio actualizadas de 51shopy reemplazarán las originales una vez publicadas y difundidas sin previo aviso. Puede consultar la última versión de las Condiciones de Servicio de 51shopy en la plataforma 51shopy. También se recomienda mantenerse al día con las Condiciones de Servicio actualizadas de 51shopy para evitar malentendidos y disputas innecesarias. Si no acepta las modificaciones de las Condiciones de Servicio de 51shopy, deje de usar los servicios de 51shopy inmediatamente. Su uso continuado de los servicios de 51shopy se considerará como la aceptación de las Condiciones de Servicio modificadas.",
    setup226: "1. Ámbito de aplicación de estas Condiciones de Servicio",
    setup227: "Los derechos de propiedad y operación de los servicios de usuario registrados pertenecen a . Los servicios prestados deben implementarse de acuerdo con las normas, términos y especificaciones operativas del servicio emitidas por esta empresa, lo que implica que los usuarios han llegado a un acuerdo con 51shopy y han aceptado todos sus términos de servicio.",
    setup228: "2. Recopilación y uso de información",
    setup229: "Cuando utiliza los servicios de 51shopy, es posible que necesitemos recopilar y utilizar los siguientes dos tipos de información personal:",
    setup230: "1. Para proporcionarle las funciones básicas de nuestros servicios, debe autorizarnos a recopilar y utilizar la información necesaria. Si se niega a proporcionar la información correspondiente, no podrá registrarse, iniciar sesión ni utilizar nuestros servicios con normalidad;",
    setup231: "2. Para brindarle funciones adicionales de nuestros servicios, puede aceptar o rechazar la información que recopilamos y utilizamos. Si se niega a proporcionarla, no podrá usar las funciones adicionales relevantes ni lograr los efectos funcionales que pretendemos lograr, y esto no afectará su uso de nuestras funciones básicas.",
    setup232: "Protegemos su derecho a saber y a elegir durante el proceso de instalación o uso de acuerdo con la ley. Al utilizar los servicios de 51shopy, los servicios que involucran funciones proporcionadas en su dispositivo requieren su consentimiento previo. Tras su confirmación, 51shopy se reserva el derecho de habilitar las funciones auxiliares necesarias, como la recopilación de ubicación geográfica, la lectura de la libreta de direcciones, el uso de la cámara y la activación de servicios de grabación.",
    setup233: "La información recopilada y utilizada incluye, entre otros, el nombre del usuario, su información de contacto y otra información básica. El usuario acepta que el uso de esta información está sujeto a las disposiciones del Artículo 3 Protección de la Información del Usuario",
    setup234: "3. Protección de la información del usuario",
    setup235: "No divulgaremos ni revelaremos su información personal a terceros a menos que:",
    setup236: "1. Compartir información necesaria para cumplir con las obligaciones legales;",
    setup237: "2. Compartir con su consentimiento;",
    setup238: "4. Derechos y obligaciones del usuario",
    setup239: "1. Tiene derecho a iniciar sesión en el sitio web de 51shopy para revisar, corregir y completar su información personal.",
    setup240: "2. Tiene derecho a contactar con el servicio de atención al cliente en línea para cancelar su cuenta. Tras la cancelación, dejaremos de prestarle servicios y eliminaremos o anonimizaremos su información personal de acuerdo con los requisitos de la legislación aplicable.",
    setup241: "3. En ciertas funciones comerciales, podemos tomar decisiones basadas únicamente en mecanismos de toma de decisiones automatizados no humanos, incluidos algoritmos. Si estas decisiones afectan sus derechos legales, puede contactarnos a través del servicio de atención al cliente.",
    setup242: "4. Toda la información que proporcione a 51shopy deberá ser veraz, precisa y no engañosa.",
    setup243: "Usted comprende y acepta que está obligado a mantener la autenticidad y validez de la información que proporciona.",
    setup244: "5. No podrá utilizar su cuenta registrada ni los servicios de 51shopy para crear, cargar, copiar, publicar o difundir contenido que interfiera con el funcionamiento normal de 51shopy o que infrinja los derechos e intereses legítimos de otros usuarios o terceros.",
    setup245: "6. No podrá copiar, plagiar, vender, revender ni utilizar con fines comerciales ninguna parte del servicio 51shopy ni el contenido utilizado u obtenido a través del mismo.",
    setup246: "7. Usted será el único responsable de la autenticidad, legalidad, exactitud y validez de cualquier información transmitida a través de su cuenta o servicios de 51shopy. Cualquier responsabilidad legal relacionada con la información que transmita será asumida por usted y no tendrá relación alguna con 51shopy. Usted deberá indemnizar por cualquier pérdida causada a 51shopy o a terceros, y 51shopy se reserva el derecho de exigir responsabilidades a los usuarios pertinentes.",
    setup247: "8. Usted será plenamente responsable de las consecuencias de todas las acciones realizadas en su cuenta (incluidas, entre otras, la firma de diversos acuerdos en línea, la publicación de información, la compra de bienes y servicios y la divulgación de información).",
    setup248: "5. Almacenamiento de información",
    setup249: "51shopy no tiene límite en la cantidad de información transmitida. Hemos tomado medidas de seguridad razonables y viables que cumplen con los estándares de la industria para proteger su información y evitar que se acceda, divulgue, utilice, modifique, dañe o pierda su información personal sin autorización. Proteja adecuadamente su información personal y compártala solo cuando sea necesario. No confíe en otras herramientas de trading para evitar el robo de información o incluso el fraude en línea",
    setup250: "6. Exención de responsabilidad",
    setup251: "1.51shopy hará todo lo posible para que la información del producto sea fiel a la realidad, pero debido a la influencia de diversos factores durante el proceso de fotografía, como el entorno, el ángulo de disparo y las diferencias de equipo, no podemos garantizar que el producto sea exactamente igual al original.",
    setup252: "2.51shopy compra los productos designados según la plataforma especificada por el usuario. Si la plataforma que usted especifica está agotada, el precio cambia, la entrega se retrasa, el producto real no coincide con la información del sitio web, el producto presenta alguna anomalía u otras causas de fuerza mayor que impidan la compra normal, nos comunicaremos con usted a tiempo. Por lo tanto, 51shopy no asume ninguna responsabilidad por las pérdidas que le ocasione.",
    setup253: "3. Si los productos que compró en 51shopy presentan problemas posventa (como falta de stock, daños, defectos, etc.), los gestionaremos de inmediato.",
    setup254: "4. 51shopy no asume ninguna responsabilidad por pérdidas o consecuencias causadas por la divulgación proactiva de su cuenta de 51shopy ni por ataques, fraudes, etc., por parte de terceros. Debe reclamar una compensación al infractor mediante recursos legales u otros medios.",
    setup255: "7. Comportamiento prohibido",
    setup256: "No puedes utilizar los servicios de 51shopy para las siguientes actividades:",
    setup257: "(1) Violación de cualquier ley, estatuto, decreto o reglamento.",
    setup258: "(2) Están involucradas las siguientes transacciones:",
    setup259: "(a) narcóticos, esteroides, ciertas drogas controladas u otros productos que puedan poner en peligro la seguridad del consumidor;",
    setup260: "(b) parafernalia de drogas;",
    setup261: "(c) Cigarrillos;",
    setup262: "(d) cannabis u otras plantas psicoactivas no autorizadas;",
    setup263: "(e) nutrición, vitaminas, suplementos, hierbas y productos naturales para la salud basados ​​en suscripción;",
    setup264: "(f) cualquier material que incite, induzca, ayude o dirija a otros a participar en actividades ilegales;",
    setup265: "(g) artículos robados, incluidos artículos digitales y virtuales;",
    setup266: "(h) materiales que inciten al odio, la violencia, la intolerancia racial u otras formas de intolerancia o que exploten actividades delictivas;",
    setup267: "(i) considerado obsceno;",
    setup268: "(j) cualquier material que infrinja o viole los derechos de autor, marca registrada, publicidad o privacidad o cualquier otro derecho de propiedad bajo las leyes de cualquier jurisdicción;",
    setup269: "(k) ciertos materiales o servicios pornográficos;",
    setup270: "(l) municiones, armas o ciertas partes o accesorios de armas, o",
    setup271: "(m) Ciertas armas o cuchillos regulados por la legislación aplicable.",
    setup272: "（3）Relacionado con las siguientes transacciones:",
    setup273: "(a) Divulgación de información personal de terceros en violación de las leyes pertinentes;",
    setup274: "(b) apoya esquemas piramidales, esquemas Ponzi, esquemas matriciales, otros esquemas de enriquecimiento rápido o ciertos esquemas de línea descendente de múltiples niveles;",
    setup275: "(c) transacciones relacionadas con la compra de anualidades o contratos de lotería, sistemas de compra de depósitos prepagos, banca offshore o transacciones para financiar o refinanciar deudas de tarjetas de crédito;",
    setup276: "(d) vender algo antes de que el vendedor tenga control o posesión de ello;",
    setup277: "(e) los procesadores de pagos cobran pagos en nombre de los comerciantes;",
    setup278: "(f) en relación con la venta de cheques de viajero o giros postales;",
    setup279: "(g) que impliquen operaciones de cambio de moneda o cobro de cheques;",
    setup280: "(h) implica ciertos servicios de reparación de crédito o liquidación de deudas, transacciones con tarjetas de crédito o actividades de seguros, o",
    setup281: "(i) implica realizar o recibir pagos relacionados con soborno o corrupción.",
    setup282: "(4) Que implique la venta de productos o servicios que las agencias gubernamentales hayan determinado que pueden ser fraudulentos.",
    setup283: "Usted asumirá la responsabilidad legal por el uso que haga de los servicios de 51shopy, incluyendo, entre otros, la compensación por las pérdidas sufridas por la parte infractora. Si 51shopy asume la responsabilidad legal inicial, como sanciones administrativas o compensación por infracciones causadas por el comportamiento del usuario, deberá pagar a 51shopy una cantidad equivalente a la compensación y otras pérdidas sufridas por 51shopy como resultado.",
    setup284: "8. Responsabilidad por indemnización",
    setup285: "1. Si sus acciones ocasionan pérdidas a 51shopy y/o sus afiliados (incluidas pérdidas económicas directas, pérdida de prestigio y pérdidas económicas indirectas, como indemnizaciones, acuerdos, honorarios de abogados, seguro de conservación, honorarios de litigio, etc.), deberá compensar a 51shopy y/o sus afiliados por todas las pérdidas.",
    setup286: "2. Si sus acciones ocasionan que 51shopy o sus afiliados sean demandados por un tercero (incluidos, entre otros, vendedores en Taobao, 1688 y otras plataformas), 51shopy o sus afiliados podrán recuperar todas las pérdidas tras asumir obligaciones como la compensación monetaria al tercero.",
    setup287: "9. Ley aplicable y jurisdicción",
    setup288: "1. Este Acuerdo de Servicio y cualquier acuerdo por separado mediante el cual le proporcionemos servicios se regirán e interpretarán de conformidad con las leyes de Hong Kong.",
    setup289: "2. Cualquier disputa que surja de su uso de los servicios de 51shopy, así como cualquier disputa relacionada con los mismos, se resolverá mediante negociación entre usted y 51shopy. Si la negociación fracasa, cualquiera de las partes podrá interponer una demanda ante el tribunal competente del lugar donde se firmó este acuerdo.",
    setup290: "El siguiente es el cronograma de salida del almacén (enviado al almacén del proveedor logístico) / retiro del proveedor logístico, solo como referencia (el cronograma real está sujeto a los acuerdos de cada proveedor logístico):",
    setup291: "Hora de entrega/recogida del paquete:",
    setup292: "Cuando el estado del paquete en el almacén de 51shopy sea 'Empaquetado', el almacén y la empresa de logística coordinarán la entrega/recogida en un horario fijo (la empresa de logística cierra los fines de semana y festivos, por lo que la recogida se pospondrá).",
    setup293: "Ruta",
    setup294: "Horario de envío/recogida (hora de Pekín)",
    setup295: "GD-EMS",
    setup296: "Recogida de lunes a domingo",
    setup297: "GD-EUB",
    setup298: "Recogida de lunes a domingo",
    setup299: "GD-E-EMS",
    setup300: "Recogida de lunes a domingo",
    setup301: "EUB-T",
    setup302: "Recogida de lunes a domingo",
    setup303: "DHL Express",
    setup304: "Recogida de lunes a sábado",
    setup305: "DHL Carga Pesada Estándar Express",
    setup306: "Recogida de lunes a sábado",
    setup307: "Línea especial europea de DHL",
    setup308: "Envío de lunes a domingo (entrega en almacén del proveedor logístico)",
    setup309: "Línea Americana (Pequeña)",
    setup310: "Envío de lunes a domingo (entrega en almacén del proveedor logístico)",
    setup311: "Línea Británica (Pequeña)",
    setup312: "Envío de lunes a domingo (entregado en el almacén del proveedor logístico)",
    setup313: "EMS de Corea",
    setup314: "Envíos desde nuestro almacén todos los días",
    setup315: "Paquete postal PDB",
    setup316: "Haibao",
    setup317: "Ferrocarriles europeos",
    setup318: "United Parcel Service Hong Kong Limited",
    setup319: "Línea dedicada Aramex",
    setup320: "SAL",
    setup331: "EMS",
    setup332: "PD-EUB",
    setup333: "Línea Británica",
    setup334: "NH-EMS",
    setup335: "Línea libre de impuestos europea",
    setup336: "Línea Americana",
    setup337: "YTO Express",
    setup338: "SF Express",
    setup339: "51shopy es una plataforma que ofrece servicios de compra y reenvío de productos chinos. Ofrece a los usuarios servicios de búsqueda, compra y reenvío de información de productos. Durante este periodo, 51shopy ofrece servicios básicos de inspección de productos, confirmación de comunicación con comerciantes y servicio posventa para proteger sus derechos e intereses legales y garantizar su experiencia de compra.",
    setup340: "Si descubre que los productos adquiridos son falsificados o de calidad inferior, póngase en contacto con nuestro servicio de atención al cliente o envíe un correo electrónico a",
    setup341: "1. Recepción e inspección: Tras comprobar la calidad del producto y depositarlo en el almacén de 51shopy, o tras recibir el paquete, si encuentra algún problema de calidad o duda de su autenticidad, póngase en contacto con el servicio de atención al cliente lo antes posible y proporcione las pruebas pertinentes.",
    setup342: "2. Materiales de reclamación: Proporcione el formulario de pedido, el recibo de pago, la descripción del producto y evidencia de productos falsificados o de calidad inferior.",
    setup343: "3. Tras recibir su queja, nuestro equipo de atención al cliente le explicará los detalles y le ayudará a comunicarse con el vendedor para resolver el problema y defender sus derechos legales.",
    setup344: "Tenga en cuenta que, debido a la autenticidad del producto, podría requerirse una evaluación profesional adicional y trámites legales. Si se requiere una agencia de evaluación profesional, usted asumirá los gastos de evaluación. Para proteger los derechos e intereses de todas las partes, le recomendamos que elija canales formales y vendedores de confianza al comprar para reducir el riesgo de adquirir productos falsificados.",
    setup345: "¿Qué es la garantía de devolución/cambio de 14 días?",
    setup346: "La garantía de devolución y cambio de cinco días es un servicio posventa especial (que incluye el servicio y la asistencia técnica) que ofrecen los vendedores de plataformas externas a los consumidores. Dentro de los 14 días posteriores a la recepción de la mercancía (es decir, dentro de los 14 días posteriores a su almacenamiento), los compradores pueden devolver o cambiar la mercancía adquirida de acuerdo con esta norma y las normas pertinentes emitidas por la plataforma externa.",
    setup347: "¿Cómo puedo determinar si un producto cumple con los requisitos para la garantía de devolución/cambio?",
    setup348: "Los productos son 'elegibles' para el servicio de devolución y cambio gratuito de 14 días, o 'no elegibles' para el servicio de devolución y cambio gratuito de 14 días",
    setup349: "¿Está disponible?",
    setup350: "Tipo",
    setup351: "Por ejemplo",
    setup352: "No disponible",
    setup353: "Se determina según la información proporcionada por el vendedor. Si no podemos confirmarlo, negociaremos con el vendedor la devolución o el cambio, pero el resultado final queda sujeto a la decisión del vendedor.",
    setup354: "Personalización",
    setup355: "Productos de diseño personalizado",
    setup356: "Explícitamente no admite devoluciones ni cambios",
    setup357: "Promocionar productos defectuosos",
    setup358: "Productos cuyo embalaje, etiquetas y accesorios han sido retirados a petición del usuario",
    setup359: "La etiqueta de la ropa está arrancada",
    setup360: "Periódicos y publicaciones periódicas",
    setup361: "Libros y revistas suscritos",
    setup362: "Productos de segunda mano",
    setup363: "Productos fuera de China continental",
    setup364: "Productos adquiridos en el extranjero y en Hong Kong y Macao",
    setup365: "Ropa interior",
    setup366: "Ropa interior, calcetines, leggings",
    setup367: "Productos para adultos",
    setup368: "Otros asuntos especificados por el vendedor",
    setup369: "Cumplir con las reglas del vendedor",
    setup370: "Comida",
    setup371: "Galletas, dulces, etc.",
    setup372: "Libros (≥15 libros)",
    setup373: "No menos de 15 libros",
    setup374: "Artículos que han sido abiertos y que deben cumplir con los 'estándares especiales' para el embalaje de devolución.",
    setup375: "Para productos de sellado, consulte la tabla adjunta",
    setup376: "Disponible",
    setup377: "Para las solicitudes de devolución o cambio enviadas dentro de los 14 días posteriores a la recepción, las procesaremos según los procedimientos estándar.",
    setup378: "Cuando el producto cumple todos los siguientes requisitos:",
    setup379: "1. El vendedor ofrece una garantía de devolución;",
    setup380: "2. En condiciones de reventa según lo exija el vendedor;",
    setup381: "3. El tiempo de almacenamiento no debe superar los 14 días.",
    setup382: "Para los productos con envío gratuito, usted será responsable de los gastos de envío al devolver el producto. Para los productos sin envío gratuito, usted será responsable de los gastos de envío cuando el vendedor envíe el producto a nuestro almacén y cuando usted lo devuelva al vendedor.",
    setup383: "Cómo solicitar el servicio de devolución/cambio",
    setup384: "Dentro de los 14 días posteriores a que el estado del pedido cambie a 'Inventario' (calculado a partir de la hora siguiente al cambio de estado, 14 días = 336 horas), puede solicitar el servicio de devolución y cambio en la página. Es posible que no se acepten solicitudes después de este plazo.",
    setup385: "Precauciones y preguntas frecuentes",
    setup386: "Notas:",
    setup387: "El importe total del reembolso/cambio se basa en el precio real del producto que pagaste",
    setup388: "Solo podemos devolver o cambiar productos si el vendedor está de acuerdo",
    setup389: "Después de solicitar el servicio de devolución/cambio, asegúrese de tener suficiente saldo en su cuenta para pagar el envío y la tarifa del servicio de devolución.",
    setup390: "Consulte la tabla a continuación para conocer los requisitos de embalaje de devolución de algunos productos. Si no los cumple, no podrá devolver ni cambiar el producto.",
    setup391: "Estándares especiales",
    setup392: "Categoría de producto",
    setup393: "Estándares especiales",
    setup394: "Zapatillas deportivas nuevas",
    setup395: "Los cierres antirrobo (si los hay) y las pegatinas antimanipulación no se han cortado ni quitado y funcionan correctamente.",
    setup396: "Detergente / Tampón / Papel / Perfume",
    setup397: "Los envases sellados de un solo uso para productos de cuidado personal, si los hay, deben permanecer sellados.",
    setup398: "Cuidado del cabello/Pelucas",
    setup399: "Los envases sellados de un solo uso para productos para el cuidado del cabello (si los hay) deben permanecer sellados.",
    setup400: "Cuidado de la piel/Cuidado corporal/Aceites esenciales",
    setup401: "El embalaje sellado desechable del producto (si lo hay) debe permanecer sellado",
    setup402: "Cosméticos/Perfumes/Herramientas de belleza",
    setup403: "Productos digitales/electrodomésticos (excepto cámaras y electrodomésticos grandes)",
    setup404: "1. La licencia de acceso a Internet no está dañada (destruida).",
    setup405: "2. Sin daños por agua.",
    setup406: "Cámara digital/Cámara SLR/Cámara",
    setup407: "El botón del obturador de una cámara SLR no debe presionarse más de 20 veces.",
    setup408: "Grandes electrodomésticos",
    setup409: "1. Televisor LCD, aire acondicionado: Aún no está instalado en la pared, se puede realizar una depuración sencilla.",
    setup410: "2. Lavadora: aún no se ha usado con agua.",
    setup411: "Modelos / Periféricos de Anime / Periféricos de Anime / Productos de Rol / Juegos de Mesa",
    setup412: "La cinta y los sellos de plástico (si los hay) de los modelos, figuras, modelos de soldados, BJD y otros productos no se pueden quitar.",
    setup413: "Componentes electrónicos",
    setup414: "1. Está prohibido soldar.",
    setup415: "2. El circuito integrado nunca se ha montado sobre ninguna base de CI.",
    setup416: "3. Los paquetes desechables sellados de consumibles, como pasta térmica, pegamento electrónico, pegamento de encapsulado, sellador, adhesivo, pegamento conductor, tinta conductora, etc., deben mantenerse sellados.",
    setup417: "Subcategoría 'Software de juegos' dentro de la categoría de primer nivel 'Videojuegos/Accesorios/Juegos/Guías de juegos'",
    setup418: "Alimentos, productos sanitarios y medicamentos para mascotas de la categoría de primer nivel 'Mascotas/Alimentos y suministros para mascotas'",
    setup419: "Libros/Revistas",
    setup420: "1. El embalaje desechable sellado del producto (si lo hay) debe permanecer sellado",
    setup421: "2. El producto no debe tener marcas de plegado, manchas de agua, suciedad, tinta o lectura.",
    setup422: "Categoría secundaria 'Productos de salud animal/Medicamentos veterinarios' dentro de la categoría principal 'Productos de cría de animales/Agricultura'",
    setup423: "Los envases sellados de un solo uso (si los hay) para productos como alimentos (incluidos suplementos), cosméticos, dispositivos médicos, anticonceptivos, productos de cuidado personal, productos para adultos, pañales para bebés, libros y productos audiovisuales deben permanecer sellados.",
    setup424: "'Sellado' se refiere al sello o embalaje plástico utilizado por el fabricante en el empaque del producto.",
    setup425: "Preguntas frecuentes:",
    setup426: "1. ¿Qué debo hacer si un pedido que no está cubierto por la 'Garantía de Devolución y Cambio' tiene problemas posventa?",
    setup427: "Si el producto presenta problemas de calidad, 51shopy verificará con el vendedor según la situación real, elaborará una solución definitiva y notificará al usuario. Si el producto no presenta problemas de calidad, según las normas de la plataforma externa, no se podrán ofrecer servicios de devolución y cambio. 51shopy hará todo lo posible por comunicarse con el vendedor para proteger los derechos e intereses de los usuarios.",
    setup428: "2. ¿Quién es responsable del envío al usar la 'Garantía de Devolución/Cambio'? ",
    setup429: "Antes de solicitar el servicio de devolución y cambio, el producto debe ser nuevo y cumplir con las condiciones de reventa. Si el producto no presenta problemas de calidad, el usuario asumirá los gastos de envío. Si el producto presenta problemas de calidad, el vendedor asumirá los gastos de envío una vez que el usuario envíe la solicitud.",
    setup430: "3. Si el estado del pedido es 'no enviado', ¿hay algún cargo por el servicio de devolución?",
    setup431: "No se preocupe, en este caso no hay ningún cargo. Solo se le cobrará si la solicitud de devolución cumple tres condiciones: primero, el producto no presenta problemas de calidad; segundo, el producto ya está en stock; y tercero, ha agotado las devoluciones gratuitas de este mes. Por lo tanto, no le cobraremos nada si el producto no se ha enviado.",
    setup432: "Correo electrónico:",
    setup433: "Tel.: +85251387262",
    setup434: "Dirección: Sala 341, 3/F, Edificio Industrial Público, 56 Hoi Yuen Road, Kwun Tong, Hong Kong",
    setup435: "Desarrollado por 51shopy - Space Network Technology Co., Ltd.",
    setup436: "Ayudarlo en el procesamiento",
    setup437: "La gran oferta de ayer",
    setup438: "Venta caliente",
    setup439: "Vendido",
    setup440: "Pago fallido",
    setup441: "Esperando el pago del franqueo",
    setup442: "Franqueo pagado, esperando confirmación del banco",
    setup443: "Franqueo pagado",
    setup444: "Especificaciones",
    setup445: "Pago real",
    setup446: "Se recomienda considerarlo detenidamente antes de cancelar un pedido. ¡La plataforma no se responsabiliza por la cancelación de un pedido!",
    setup447: "Cambiar pago",
    setup448: "Pagar franqueo",
    setup449: "Pedido de centro comercial",
    setup450: "Más",
    setup451: "Tienda",
    setup452: "Adquisitivo",
    setup453: "Liberar",
    setup454: "Vender",
    setup455: "Historial",
    setup456: "Orden de compra",
    setup457: "Importe a pagar",
    setup458: "Entrar a la tienda",
    setup459: "Ver más",
    setup460: "Colapso",
    setup461: "Entrar",
    setup462: "El producto se ha agotado.",
    setup463: "Recomendamos los siguientes productos similares",
    setup464: "Productos similares",
    setup465: "Descargo de responsabilidad",
    setup467: "El embalaje se refiere al embalaje original del producto. Si se inspecciona, se retirará el embalaje logístico, excepto el producto. Para evitar daños al producto, se conservarán los materiales de embalaje de protección necesarios. No nos responsabilizamos si solicita retirar el embalaje.",
    setup468: "Flete nacional integral. Para mercancías del mismo vendedor, la desviación del flete será ajustada por nosotros.",
    setup469: "Tomaremos de 3 a 7 fotos de cada producto sin costo alguno. Si necesita servicios fotográficos adicionales, podríamos cobrarle una pequeña tarifa.",
    setup470: "Los productos personalizados no admiten devoluciones ni cambios.",
    setup471: "Para productos aprobados para devolución y cambio por el vendedor, puede solicitar la devolución y el cambio dentro de los 14 días posteriores a que el estado del pedido cambie a 'En stock'. Al solicitar una devolución y un cambio, deberá asumir una tarifa de gestión de aproximadamente US$0,75 y los gastos de envío nacional por cada producto devuelto, cuyo importe total es de aproximadamente US$3.",
    setup472: "Todo",
    setup473: "Ruta postal",
    setup474: "Tarifa de envío",
    setup475: "Se requiere la información de largo, ancho y alto del paquete",
    setup476: "Tiempo de transporte",
    setup477: "día",
    setup478: "Libre de impuestos",
    setup479: "Se puede asegurar",
    setup480: "Est. envío",
    setup481: "Recuperar registro de contraseñas",
    setup482: "Comerciante",
    setup483: "Por favor",
    setup484: "Pagar, de lo contrario se cancelará el pedido",
    setup485: "Precio total de los bienes",
    setup486: "Total a pagar",
    setup487: "Pagar ahora",
    setup488: "Saldo insuficiente, por favor recargue y pague",
    setup489: "¿No encuentras un método de pago adecuado? Puedes intentar pagar con tu saldo primero",
    setup490: "Ya en stock",
    setup491: "Se ha cotizado el flete",
    setup492: "Tarifa de envío pagada",
    setup493: "Envío fuera de stock",
    setup494: "Continuar pagando",
    setup495: "Número de pedido de logística internacional",
    setup496: "Número de pedido de logística nacional",
    setup497: "Su navegador no admite el reproductor de vídeo HTML5.",
    setup498: "¡Solo se admite la carga de imágenes en formato PNG y JPEG!",
    setup499: "Completado",
    setup500: "retorno",
    setup501: "No tienes permiso para acceder a esta página",
    setup502: "Cálculo de transporte",
    setup503: "Cooperar con diversas empresas de logística para ofrecer los mejores descuentos",
    setup504: "Est. envío",
    setup505: "Buscar productos",
    setup506: "Ver productos según criterios de búsqueda",
    setup507: "Información básica",
    setup508: "Por favor ingrese el nombre en inglés",
    setup509: "Por favor ingrese el nombre chino",
    setup510: "¡Los videos subidos solo pueden estar en formato MP4, WebM u OGG!",
    setup511: "¡El tamaño del video subido no puede superar los 2 MB!",
    setup512: "La duración del video no puede exceder",
    setup513: "segundos",
    setup514: "No se puede obtener la duración del video, verifique si el archivo de video está dañado",
    setup515: "datos",
    setup516: "",
    setup517: "Por favor ingrese el SKU",
    setup518: "Por favor ingrese la cantidad",
    setup519: "Por favor ingrese el precio",
    setup520: "Por favor ingrese los detalles del producto en inglés",
    setup521: "Ingrese los detalles del producto en chino",
    setup522: "Chino simplificado",
    setup523: "Español",
    setup524: "Portugués",
    setup525: "Holandés",
    setup526: "Polaco",
    setup527: "Alemán",
    setup528: "Francés",
    setup529: "Italiano",
    setup530: "Habilitar múltiples especificaciones",
    setup531: "Precio (CNY)",
    setup532: "Añadir pics specs",
    setup533: "Añadir Fotos Spec",
    setup534: "① Haga doble clic para modificar, arrastre para ajustar el orden",
    setup535: "Agregar especificaciones",
    setup536: "Configuración del lote",
    setup537: "Por favor, publique en el lado de la PC",
    setup538: "Nombre",
    setup539: "Subir vídeo del producto",
    setup540: "Hora de entrada al almacén",
    setup541: "Hora de salida del almacén",
    setup543: "Mi lanzamiento",
    setup544: "Por favor, autentíquese como comerciante antes de publicar el producto",
    setup545: "Por favor, vaya al PC para publicar el producto",
    setup546: "Destino",
    setup547: "Estados Unidos",
    setup548: "Peso (gramos)",
    setup549: "Categoría del producto",
    setup550: "Seleccione la categoría",
    setup551: "Largo",
    setup552: "Ancho",
    setup553: "Alto",
    setup554: "CONSULTA",
    setup555: "A todo riesgo",
    setup556: "Se puede asegurar",
    setup557: "Libre de impuestos",
    setup558: "Gastos de envío",
    setup559: "Se necesita información sobre el largo, ancho y alto del paquete",
    setup560: "Tiempo de transporte",
    setup561: "Días",
    setup562: "¡Pago cancelado correctamente!",
    setup563: "Recordatorio de días: Seleccione su país de destino y el sistema buscará rutas disponibles en esa ubicación",
    setup564: "Restricciones de paquetes",
    setup565: "Límite de peso mínimo:",
    setup566: "Límite de peso máximo:",
    setup567: "Reglas de facturación por peso volumétrico:",
    setup568: "Límite de tamaño:",
    setup569: "No se puede enviar",
    setup570: "Se puede enviar",
    setup571: "Estándares de tarifa:",
    setup572: "Unidad de peso",
    setup573: "Precio unitario",
    setup574: "Tarifa aduanera",
    setup575: "Costo de combustible",
    setup576: "Tarifa de operación",
    setup577: "¡El límite de crédito de este banco es insuficiente, por lo que no puede seleccionarlo!",
    setup578: "El saldo de 51coin es insuficiente, ¡por favor recárguelo!",
    setup579: "observación",
    setup580: "¡Seleccione el producto que desea eliminar!",
    setup581: "Iniciar sesión con Google",
    setup582: "La primera imagen es la principal por defecto. Arrastra para cambiar.",
    setup583: "Límite máximo de carga alcanzado",
    setup584: "Iniciar sesión con telegram",
    setup585: "Ver logística",
    setup586: "Información logística",
    setup587: "Modificar número de orden logística",
    setup588: "Buzón vinculado",
    setup589: "Por favor, vincule el buzón primero",
    setup590: "¡Puedes ingresar hasta 2 tipos de especificaciones!",
    setup591: "Plantillas comunes",
    setup592: "Seleccionar modelo",
    setup593: "Cancelar",
    setup594: "Agregar",
    setup595: "Seleccione el valor de especificación",
    setup596: "No agregar repetidamente",
    setup597: "¡Las plantillas comunes se configuraron correctamente!",
    setup598: "El SKU no puede estar vacío",
    setup599: "El precio no puede estar vacío",
    setup600: "La cantidad no puede estar vacía",
    setup601: "¡No se puede agregar el mismo valor de especificación!",
    setup602: "① Haga doble clic para modificar",
    setup603: "¡Por favor, complete la información de especificación!",
    setup604: "¡Por favor, complete los detalles del producto en chino simplificado e inglés!",
    setup605: "Modificación exitosa",
    setup606: "¡Agregar valor de especificación exitosamente!",
    setup607: "Establecer como común",
    setup608: "¡Ingrese al menos un valor de especificación!",
    setup609: "Por favor ingrese chino simplificado",
    setup610: "Por favor ingrese inglés",
    setup611: "Por favor ingrese español",
    setup612: "Por favor ingrese portugués",
    setup613: "Por favor ingrese holandés",
    setup614: "Por favor ingrese polaco",
    setup615: "Por favor ingrese alemán",
    setup616: "Por favor ingrese francés",
    setup617: "Por favor ingrese italiano",
    setup618: "Traducción automática",
    setup619: "Traducción",
    setup620: "Todos los demás",
    setup621: "INFORMACIÓN DE ENVÍO",
    setup622: "Nuestro objetivo es ofrecerte las mejores opciones de envío, sin importar dónde vivas. Entregamos a cientos de clientes en todo el mundo a diario y nos esforzamos por brindarte un servicio de la más alta calidad",
    setup623: "A. El plazo de entrega de un pedido se divide en dos partes:",
    setup624: "· Tiempo de procesamiento: 3-7 días",
    setup625: "· Tiempo de envío: 14-30 días",
    setup626: "B. Métodos de envío",
    setup627: "C. Gastos de envío",
    setup628: "Derechos de propiedad intelectual",
    setup629: "Transporte terrestre/marítimo",
    setup630: "Esperando recibo",
    setup631: "Alianza",
    setup632: "Comparte tu código de afiliado",
    setup633: "Los amigos que invitaste confirman que recibieron tu código de alianza",
    setup634: "Recibe tu comisión de afiliado",
    setup635: "Copia esta URL y úsala para redirigir a los usuarios a la página de inicio de tu ID de afiliado",
    setup636: "Copiar URL",
    setup637: "Mi alianza",
    setup638: "Grabar",
    setup639: "Obtener",
    setup640: "Preguntas frecuentes sobre equidad",
    setup641: "¿Qué es el programa de afiliados?",
    setup642: "51Shopy es un proyecto de intercambio y generación de ingresos impulsado por todos los usuarios. Ya seas particular o vendedor, únete a un promotor de 51Shopy, invita a nuevos usuarios a registrarse y realizar una compra exitosa. Se convertirán en tus usuarios exclusivos y recibirás reembolsos en efectivo por cada compra realizada en logística internacional. El reembolso puede alcanzar un millón de yuanes, sin límite máximo.", 
    setup643: "¿Cómo se calcula mi bonificación?",
    setup644: "Una vez que te hagas miembro, tu cuenta recibirá un reembolso inmediatamente. Cuantos más usuarios de logística internacional invites a registrarse, más bonificaciones recibirás y mayor será tu reembolso. Cuando el bono alcance cierta cantidad, podrás solicitar un retiro en efectivo o usarlo para compensar las comisiones de servicio de la plataforma 51Shopy. El reembolso es...",
    setup645: "¿Cómo promocionar gratis?",
    setup646: "Copia tu enlace promocional y envíaselo a tus amigos haciendo clic en Compartir en la página del producto. Cuando visiten y se registren, se convertirán en tus usuarios únicos.",
    setup647: 'Hora de registro',
    setup648: 'Costos de transporte',
    setup649: 'Estado de activación',
    setup650: 'Registro de bonificación',
    setup651: 'Hora de la aplicación',
    setup652: 'Recompensa total',
    setup653: 'Invitar usuarios',
    setup654: 'Ir a la billetera',
    setup655: "Tarjeta de crédito",
    setup656: "Invita a tus amigos a disfrutar de la comisión.",
    setup657:"Miembro afiliado",
    setup658: "Orden de compra",
    setup659: "La plataforma de agente 51Shopy te ayuda a comprar productos online y offline en China. Solo tienes que proporcionar el enlace del producto y realizar el pedido; nuestro equipo te brindará un servicio de primera clase de principio a fin",
    setup660: "Enviar al almacén",
    setup661: "Con nosotros, puedes comprar productos de varios vendedores y enviarlos al almacén de 51Shopy en China",
    setup662: "Inspección de calidad",
    setup663: "Una vez que sus artículos lleguen al almacén de 51Shopy, realizaremos una inspección de calidad exhaustiva, abarcando desde defectos hasta tallas y colores. Puede estar seguro de que 51Shopy ofrece una garantía de servicio posventa confiable.",
    setup664:"Entrega global",
    setup665: "En el almacén de 51Shopy, puedes elegir y combinar libremente productos, y utilizar el confiable servicio logístico que ofrece 51Shopy para empaquetarlos y entregarlos a domicilio.",
    setup666: "Servicio integral, sin preocupaciones durante todo el proceso",
    setup667:"Una vez que los usuarios que invites se registren, recibirán USD:",
    setup668: "Envío gratuito",
    setup669: "Sin incluir gastos de envío",
    setup670: "El envío internacional no está incluido",
    setup671:"Empresa de Logística",
    setup672: "Seleccionar una empresa de logística",
    setup673: "Último número del remitente",
    setup674: "Últimos cuatro dígitos",
    setup675: "Número de consignatario",
    setup676:"Por favor ingrese",
    setup677: "Esperando almacenamiento",
setup678: "¿Incluye envío internacional?",
setup679: "Sí",
setup680: "No",
setup681: "Haga clic en el botón 'Agregar a la pantalla de inicio'",
}
//西班牙